require('./jv.Admin.Users.Administration.Controller');
require('./jv.Admin.Users.Administration.Details.Controller');
require('./jv.Admin.Users.Administration.Service');
require('../jv.Admin.Users.Ajax.Factory.js');
require('../jv.Admin.Users.PostParamFAC.js');
require('../../../common/jv.Jobvite.Urls.js');
require('../../../common/jv.Roles.Permissions.directive.js'),
require('../../../common/directives/jv.HideOnBlur.js')

angular.module('jv.admin.users.administration.app', [
  'ngRoute',
  'jv.Admin.Users.Administration.Controller',
  'jv.Admin.Users.Administration.Details.Controller',
  'jv.Admin.Users.Administration.Service',
  'jv.Admin.Users.Ajax.Factory',
  'jv.Admin.Users.PostParams.Factory',
  'jv.Common.Jobvite.Urls',
  'jv.Roles.permissions.directive',
  'jv.Common.Directives.HideOnBlur'
])
.config(['$routeProvider', '$locationProvider', function($routeProvider, $locationProvider) {
  $routeProvider.when('/users/employee/permissions/:id/:index/:count/:page', {
      templateUrl: 'details.html',
  });
  $locationProvider.hashPrefix('');
}]);
